/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState;
(function (FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState) {
    FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState[FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState["CanBeTransferred"] = 0] = "CanBeTransferred";
    FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState[FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState["AlreadyTransferred"] = 1] = "AlreadyTransferred";
    FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState[FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState || (FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState = {}));
export function instanceOfFxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState(value) {
    for (const key in FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState) {
        if (Object.prototype.hasOwnProperty.call(FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState, key)) {
            if (FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateFromJSON(json) {
    return FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateToJSON(value) {
    return value;
}
export function FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferStateToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdApplicationHandlersAuthInfoAuthenticateWithExternalIdMyGamesOauthTransferState.js.map